import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './styles.module.scss';

function Heading(props) {
  const HeadingTag = props.tag;
  return <HeadingTag className={classnames([styles.heading, ...props.styles])}>{props.children}</HeadingTag>;
}

Heading.propTypes = {
  tag: PropTypes.string,
  styles: PropTypes.array,
  children: PropTypes.any
};

Heading.defaultProps = {
  tag: 'h3',
  styles: [],
  children: null
};

export default Heading;
